const fieldAccessDestructor = (accesses = [], field, currentState, disableStateCanEditThisField) => {
  const foundedFieldAccessObj =
    accesses && Array.isArray(accesses) ? accesses?.find((acc) => acc?.fieldName === field) : null;
  if (foundedFieldAccessObj) {
    const canSee = foundedFieldAccessObj?.selectAccess;
    const canManipulate =
      currentState !== "unset"
        ? disableStateCanEditThisField
          ? true
          : foundedFieldAccessObj?.manipulationAccess &&
            foundedFieldAccessObj?.statesCanEditThisField
              ?.split("-")
              ?.filter((which) => which !== "")
              ?.includes(currentState)
        : foundedFieldAccessObj?.manipulationAccess;

    return [canSee, canManipulate];
  } else {
    return [false, false];
  }
};

export default fieldAccessDestructor;
